import {
  APPLICATION_READ,
  DASHBOARD_READ,
  ENTITY_READ,
  LOANS_READ,
  PLAID_READ, OWNER,
} from '@/libs/permissions_list';


export default {
  sections: [
    {
      component: 'b-nav-item-dropdown',
      text: 'LOANS',
      items: [
        {
          text: 'Fix and Flip Loans',
          link: 'https://www.anchorloans.com/loans/fix-and-flip-loans',
        },
        {
          text: 'New Construction Loans',
          link: 'https://www.anchorloans.com/loans/new-construction-loans',
        },
      ],
    },
    {
      component: 'b-nav-item',
      text: 'INVEST',
      href: 'https://www.anchorloans.com/invest',
    },
    {
      component: 'b-nav-item',
      text: 'BROKER',
      href: 'https://www.anchorloans.com/broker',
    },
    {
      component: 'b-nav-item-dropdown',
      text: 'ABOUT',
      items: [
        {
          text: 'About Anchor',
          link: 'https://www.anchorloans.com/about',
        },
        {
          text: 'About the CEO',
          link: 'https://www.anchorloans.com/about_ceo',
        },
        {
          text: 'About the Account Executive',
          link: 'https://www.anchorloans.com/about/account-executives',
        },
      ],
    },
    {
      component: 'b-nav-item-dropdown',
      text: 'RESOURCES',
      items: [
        {
          text: 'California',
          link: 'https://www.anchorloans.com/WeKnowCalifornia',
        },
        {
          text: 'Florida',
          link: 'https://www.anchorloans.com/WeKnowFlorida',
        },
        {
          text: 'Georgia',
          link: 'https://www.anchorloans.com/WeKnowGeorgia',
        },
        {
          text: 'Illinois',
          link: 'https://www.anchorloans.com/WeKnowIllinois',
        },
        {
          text: 'Pennsylvania',
          link: 'https://www.anchorloans.com/WeKnowPennsylvania',
        },
        {
          text: 'Tennessee',
          link: 'https://www.anchorloans.com/WeKnowTennessee',
        },
        {
          text: 'Texas',
          link: 'https://www.anchorloans.com/WeKnowTexas',
        },
        {
          text: 'Press',
          link: 'https://www.anchorloans.com/category/press',
        },
      ],
    },
    {
      component: 'b-nav-item',
      text: 'BLOG',
      href: 'https://www.anchorloans.com/blog',
    },
  ],
  userItems: [
    {
      text: 'Dashboard',
      icon: 'address-card',
      route: { name: 'Dashboard' },
      permissions: [DASHBOARD_READ],
    },
    {
      text: 'Submit New Loan',
      icon: 'plus',
      route: { name: 'NewDeal' },
      exact: true,
      permissions: [LOANS_READ],
    },
    {
      text: 'Loans',
      icon: 'handshake',
      route: { name: 'MyDeals' },
      permissions: [LOANS_READ],
    },
    {
      text: 'Entities',
      icon: 'building',
      route: { name: 'EntitiesList' },
      permissions: [ENTITY_READ],
    },
    {
      text: 'Guarantor and Borrower Application',
      icon: 'copy',
      route: { name: 'Guarantor' },
      permissions: [APPLICATION_READ],
    },
    {
      text: 'Proof of Funds',
      icon: 'plaid-icon',
      route: { name: 'Plaid' },
      permissions: [PLAID_READ],
    },
    {
      text: 'Team Members',
      icon: 'list-ul',
      exact: true,
      route: { name: 'Settings', query: { tab: 3 } },
      permissions: [OWNER],
    },
  ],
  anchorBrand: {
    title: 'Anchor Loans',
    alt: 'Click to go to anchorloans.com',
  },
};



// WEBPACK FOOTER //
// ./src/components/base/navbar/resources.js